@if(attribute?.currentValue) {
  <div class="column-grid tw-gap-4 tw-grid-cols-[22%_1fr]">

    <app-restricted-input
      class="restricted-input"
      [value]="attribute.currentValue"
      [fixedDecimal]="2"
      [type]="'number'"
      [label]="attribute.label"
      [disabled]="shouldBeDisabled()"
      [step]="attribute.incrementSize"
      [min]="attribute.currentBoundaries?.min"
      [max]="attribute.currentBoundaries?.max"
      (valueChange)="onChange($event)"
    />

    @if(shouldShowSlider()) {

      @switch (attribute.dynamicType) {
        @case (DynamicApprovalAttributeTypes.labeledSet) {
          @if(attribute.options) {
            <app-restricted-radio
              [options]="labeledOptions()"
              [disabled]="disabled"
              (valueChange)="onChange($event)"
              [value]="attribute.currentValue"
            ></app-restricted-radio>
          }
        }

        @case (DynamicApprovalAttributeTypes.numericSet) {
          @if(attribute.options) {
            <app-discrete-slider
              (valueChange)="onChange($event)"
              [disabled]="disabled"
              [thumbLabel]="true"
              [value]="attribute.currentValue"
              [marks]="numericOptions()"
            >
            </app-discrete-slider>
          }
        }

        @case (DynamicApprovalAttributeTypes.range) {

          <app-restricted-slider
            [updateContinuously]="true"
            [value]="attribute.currentValue"
            [showValues]="true"
            [currency]="attribute.displayType === ApprovalAttributeDisplayTypes.currency"
            [showCurrencyDecimals]="false"
            [tickInterval]="0"
            [thumbLabel]="true"
            [disabled]="shouldBeDisabled()"
            [step]="attribute.incrementSize"
            [min]="attribute.globalBoundaries.min"
            [max]="attribute.globalBoundaries.max"
            [availableMax]="attribute.currentBoundaries.max"
            [availableMin]="attribute.currentBoundaries.min"
            (valueChange)="onChange($event)"
          />

        }
      }

    }

  </div>
}
